// Recovered compiled webpack factory 80749. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e, t) {
    return (
      void 0 === t && (t = ""),
      ("/" === e ? "/index" : /^\/index(\/|$)/.test(e) ? "/index" + e : e) + t
    );
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
